import TimeSelectorContainer from './TimeSelectorContainer';

export default TimeSelectorContainer;



// WEBPACK FOOTER //
// ./src/components/molecules/TimeSelector/index.js